export default {
    excess: 'udział własny',
    security: 'Kaucja zabezpieczająca',
    fuel_policy: 'Zasady dotyczące paliwa',
    like_for_like: 'Podobny poziom',
    full_to_full: 'Pełny bak',
    mileage: 'Przebieg: {mileage} mil(e) na wypożyczenie',
    unlimited_mileage: 'Nieograniczony przebieg',
    non_refundable: 'Nie podlega zwrotowi',
    free_cancellation_until: 'Bezpłatne anulowanie przed {date}',
    cancellation_with_terms: 'Anulowanie zgodnie z {0} ',
    t_c_text: 'Regulamin',
    two_free_extras: 'Dwa bezpłatne dodatki przy odbiorze',
    glass_tyres_covered: 'Obejmuje szyby i opony'
}
